<template>
  <main class="content">
    <Hero title="Wachtwoord resetten"/>
    <main class="main block maxw--neck">
      <p class="text--center mb-2">
        Hieronder kun je het nieuwe wachtwoord invoeren en deze bevestigen door deze nogmaals in te vullen
      </p>
      <form class="form" @submit.prevent="submit">
        <fieldset class="form__fieldset">
          <div class="form__row">
            <FormTextField name="password" type="password" label="Nieuw wachtwoord" v-model="v$.password.$model" :validator="v$.password"/>
          </div>
          <div class="form__row">
            <FormTextField name="passwordConfirmation" type="password" label="Nieuw wachtwoord herhalen" v-model="v$.passwordConfirmation.$model" :validator="v$.passwordConfirmation"/>
          </div>
          <div class="form__row">
            <div class="field">
              <button class="btn btn--full mt-2" type="submit" :disabled="isLoading">
                Wachtwoord wijzigen
                <Spinner v-if="isLoading" />
              </button>
            </div>
          </div>
          <div class="form__row" v-if="!neutral">
            <span class="field__status text--center" :class="feedbackClass">{{ feedbackMessage }}</span>
          </div>
        </fieldset>
      </form>
      <div class="vertical-center mt-2">
        <nuxt-link to="/" class="btn btn--flat">Terug naar homepagina</nuxt-link>
      </div>
    </main>
  </main>
</template>

<script lang="ts" setup>
import useVuelidate from '@vuelidate/core';
import { helpers, required, sameAs } from '@vuelidate/validators';

useHead({
  title: 'Wachtwoord resetten'
});

const route = useRoute();
const { resetPassword } = useStrapiAuth();
const { isLoading, startLoading, stopLoading } = useLoading();
const { feedbackMessage, resetStatus, setStatus, handleSuccess, neutral, feedbackClass } = useSubmitFeedback(
  'Wachtwoord succesvol gereset',
  'Er is iets fout gegaan. Probeer het later opnieuw'
);

const password = ref('');
const passwordConfirmation = ref('');
const $externalResults = ref({});

async function submit(e: Event) {
  resetStatus();

  if (!(await v$.value.$validate()) || isLoading.value) return;

  startLoading();

  try {
    await resetPassword({ 
      code: route.query.code?.toString() ?? '', 
      password: password.value, 
      passwordConfirmation: passwordConfirmation.value
    });

    handleSuccess();
  } catch (e) {
    setStatus(false);
  } finally {
    stopLoading();
  }
}

const rules = computed(() => ({
  password: {
    required: helpers.withMessage('Dit veld is verplicht', required)
  },
  passwordConfirmation: {
    required: helpers.withMessage('Dit veld is verplicht', required),
    sameAs: helpers.withMessage('De wachtwoorden komen niet overeen', sameAs(password))
  }
}));

const v$ = useVuelidate(rules, { password, passwordConfirmation }, { $externalResults });

definePageMeta({
  pageTransition: pageTransitionConfig,
});
</script>
